export const COMPLETE_CASES_PATH =
  "/api/internal/applicant/case/complete/" as const;

export const OUTSTANDING_REQUEST_STATUS = "WAITING_ON_APPLICANT" as const;

export function informationRequestsPath(caseId: string) {
  return `/api/internal/applicant/case/${caseId}/additional-information-requests/` as const;
}

export function informationRequestPath(caseId: string, requestId: string) {
  return `/api/internal/applicant/case/${caseId}/additional-information-requests/${requestId}/` as const;
}

export const DOCUMENT_CONTENT_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
];
export const MAX_DOCUMENT_SIZE_BYTES = 10 * 1024 * 1024;
export const MAX_UPLOAD_FILENAME_LENGTH = 112;

export function itemTextResponsePath(caseId: string, itemId: string) {
  return `/api/internal/applicant/case/${caseId}/additional-information-requests/items/${itemId}/text-response/` as const;
}

export function itemCannotProvidePath(caseId: string, itemId: string) {
  return `/api/internal/applicant/case/${caseId}/additional-information-requests/items/${itemId}/cannot-provide/` as const;
}

export function itemUploadUrlPath(caseId: string, itemId: string) {
  return `/api/internal/applicant/case/${caseId}/additional-information-requests/items/${itemId}/upload-url/` as const;
}

export function itemDocumentsPath(caseId: string, itemId: string) {
  return `/api/internal/applicant/case/${caseId}/additional-information-requests/items/${itemId}/documents/` as const;
}

export function documentRemovePath(caseId: string, documentId: string) {
  return `/api/internal/applicant/case/${caseId}/additional-information-requests/documents/${documentId}/remove/` as const;
}

export function documentDownloadUrlPath(caseId: string, documentId: string) {
  return `/api/internal/applicant/case/${caseId}/additional-information-requests/documents/${documentId}/download-url/` as const;
}

export function informationRequestsSubmitPath(caseId: string) {
  return `/api/internal/applicant/case/${caseId}/additional-information-requests/submit/` as const;
}

export function itemSubmitPath(caseId: string, itemId: string) {
  return `/api/internal/applicant/case/${caseId}/additional-information-requests/items/${itemId}/submit/` as const;
}

export function informationRequestPagePath(caseId: string) {
  return `/${caseId}/information-request`;
}
